import { Entity } from "../../helpers/Entity"


type RefundPaymentAttributes = {
    identifier: string,
    amount: number,
    refundMethod: string,
    refundedPaymentId: string,
    status: string,
}

export type RefundPaymentDto = {
    id: string
    type: string
    attributes: RefundPaymentAttributes
}

export default class RefundPayment implements Entity {
    private dto: RefundPaymentDto

    constructor(dto: RefundPaymentDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === "refund-payment"
    }

    getPayment() : RefundPaymentDto {
        return this.dto
    }

    getId(): string {
        return this.dto.id
    }

    getIdentifier(): string {
        return this.dto.attributes.identifier
    }

    getAmount(): number {
        return this.dto.attributes.amount
    }

    getRefundedPaymentId(): string {
        return this.dto.attributes.refundedPaymentId
    }

    getRefundMethod(): string {
        return this.dto.attributes.refundMethod
    }

    getStatus(): string {
        return this.dto.attributes.status
    }
}


// WEBPACK FOOTER //
// ./src/state/payment/refund/RefundPayment.ts